var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Storage } from '../../../../lib/localstorege.service';
import { currencyFormat, dateTimeFormat, initialLeftMenu, sportsMenu, useForceUpdate, } from '../../../../lib/misc.functions';
import { modalServiceSubject } from '../../../../components/modal/modal';
import { useNavigate } from 'react-router-dom';
import { env } from '../../../../definitions/global.vars';
import { Subject } from 'rxjs';
import { ApiService } from '../../../../lib/http.service';
import { betSlipActionSubject, } from '../../../../store/betslip.store';
import ExitIcon from '../../../../assets/feather/x-circle.svg';
import { shareOnSocial } from '../../../../services/sosyoley.services';
import Whatsapp from '../../../../assets/feather/share-2.svg';
import Modal from 'react-modal';
import { agfCondBets, availableBettingSubTypes, availableHippodromes, availableTjkBettingTypes, DailyRaces, tjkBetSlipOptions, tjkBettingTypesMap, tjkBettingTypesMap2, tjkFobBettingTypes, tjkLongtermBettingTypes, tjkHippodromsMap, tjkOrderedBetTypes, tjkSortedBetTypes, } from '../../../tjk/tjk.store';
import { getAvailableBettingSubTypes, getAvailableBettingTypes, getAvailableHippodromes, getAvailableRuns, getDailyRaces } from '../../../tjk/tjk.utils';
import iconFather from '../../../../assets/feather/father-at-yarisi.svg';
import { isMobile } from "../../../../app/Routes";
import paths from "../../../../app/paths";
import { GameOperationsSelect } from "../../widgets/selected";
import { tjkBetslipStore } from "../../../tjk/components/tjk.betslip";
import { addToTJKBetSlip, updateBetCount } from "../../../tjk/tjk.betslip.service";
export var tjkCouponDetailSubject = new Subject();
function parseTjkCard(card) {
    var parts = card.split('-');
    var dateNum;
    var hippodrome;
    if (parts[0].length === 8) {
        // DDMMYYYY-hippodrome
        dateNum = parts[0];
        hippodrome = parts[1];
    }
    else {
        // YYYY-MM-DD-hippodrome
        dateNum = parts[2] + parts[1] + parts[0];
        hippodrome = parts.slice(3).join('-');
    }
    var dateFormatted = dateNum.substring(4, 8) + '-' + dateNum.substring(2, 4) + '-' + dateNum.substring(0, 2);
    return { dateNum: dateNum, hippodrome: hippodrome, dateFormatted: dateFormatted };
}
function playTJKSavedCoupon(coupon, navigate) {
    var _a, _b, _c, _d;
    tjkBetslipStore.splice(0);
    tjkBetSlipOptions.hippodrome = null;
    tjkBetSlipOptions.bettingType = null;
    tjkBetSlipOptions.bettingSubType = null;
    tjkBetSlipOptions.betSlipMultiply = 1;
    tjkBetSlipOptions.complete = false;
    tjkBetSlipOptions.system = false;
    var betTypeId = Number(coupon.bet_type);
    if (tjkLongtermBettingTypes.includes(betTypeId)) {
        return;
    }
    var hippodrome = availableHippodromes.find(function (hippodrome) { return Number(hippodrome.card_id) === Number(coupon.card_id); });
    if (betTypeId === 1883) {
        var allLegsPlayable = coupon.legs.every(function (leg) {
            var _a;
            var keys = Object.keys(leg);
            var parts = keys[0].split('_');
            var run = parts[1];
            var currentBetTypeId = parts[2];
            var currentHipKey = parts[0];
            var legHippodrome = availableHippodromes.find(function (h) {
                return "".concat(h.id.split('-')[0], "-").concat(h.keyword.toLowerCase()) === currentHipKey;
            });
            var betType = (_a = legHippodrome === null || legHippodrome === void 0 ? void 0 : legHippodrome.wager_details) === null || _a === void 0 ? void 0 : _a.find(function (w) { return Number(w.type) === Number(currentBetTypeId); });
            return betType && betType.runs.includes(Number(run));
        });
        if (!allLegsPlayable) {
            modalServiceSubject.next({
                title: 'Kapanmış Bahis',
                innerHtml: true,
                content: '<div class="text-center"><p>Bu kupon artık oynanabilir değil.</p></div>',
                confirm: {
                    cancel: {
                        label: "Tamam",
                    },
                },
            });
            return;
        }
        var currentHipId = null;
        var _loop_1 = function (leg) {
            var keys = Object.keys(leg);
            var values = Object.values(leg);
            var parts = keys[0].split('_');
            var currentHipKey = parts[0];
            var currentRun = parts[1];
            var currentBetTypeId = parts[2];
            var legHippodrome = availableHippodromes.find(function (h) {
                return "".concat(h.id.split('-')[0], "-").concat(h.keyword.toLowerCase()) === currentHipKey;
            });
            if (!legHippodrome)
                return "continue";
            if (legHippodrome.id !== currentHipId) {
                currentHipId = legHippodrome.id;
                tjkBetSlipOptions.hippodrome = legHippodrome;
                getAvailableBettingTypes();
                getAvailableRuns(true);
            }
            tjkBetSlipOptions.bettingType = availableTjkBettingTypes.find(function (el) { return Number(el.id) === Number(currentBetTypeId); });
            if (!tjkBetSlipOptions.bettingType)
                return "continue";
            getAvailableBettingSubTypes(legHippodrome);
            tjkBetSlipOptions.bettingSubType = availableBettingSubTypes.find(function (el) { return Number(el) === Number(currentRun); }) || availableBettingSubTypes[0] || null;
            var run = legHippodrome.runs.find(function (r) { return Number(r.no) === Number(currentRun); });
            if (!run)
                return "continue";
            values.forEach(function (horseList) {
                var horses = Array.isArray(horseList) ? horseList : [horseList];
                var isPair = horses.length > 1;
                horses.forEach(function (horseNo, pairIndex) {
                    var cleanNo = String(horseNo).replace(/T[234]$/, '').trim();
                    var _horse = run.horses.find(function (h) { return Number(h.no) === Number(cleanNo); });
                    if (_horse === null || _horse === void 0 ? void 0 : _horse.run_status) {
                        addToTJKBetSlip(1, run, _horse, 'add');
                    }
                });
            });
        };
        for (var _i = 0, _e = coupon.legs; _i < _e.length; _i++) {
            var leg = _e[_i];
            _loop_1(leg);
        }
        tjkBetSlipOptions.betSlipMultiply = coupon.multiply;
        updateBetCount.status = true;
        betSlipActionSubject.next({ action: "clear", data: null });
        navigate("/".concat(paths.TJK, "/fob-bulten/").concat(((_b = (_a = tjkBetSlipOptions.hippodrome) === null || _a === void 0 ? void 0 : _a.keyword) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || '', "/"));
        return;
    }
    var betType = (_c = hippodrome === null || hippodrome === void 0 ? void 0 : hippodrome.wager_details) === null || _c === void 0 ? void 0 : _c.find(function (w) { return Number(w.type) === betTypeId; });
    var isPlayable = betType && betType.runs.includes(coupon.race_id);
    if (isPlayable) {
        var slipItem = tjkBetslipStore.filter(function (el) {
            if (Number(el.hippodrome.card_id) === Number(hippodrome.card_id) &&
                Number(el.bettingType.id) === Number(coupon.bet_type)) {
                return el;
            }
        });
        for (var _f = 0, slipItem_1 = slipItem; _f < slipItem_1.length; _f++) {
            var item = slipItem_1[_f];
            tjkBetslipStore.splice(tjkBetslipStore.indexOf(item), 1);
        }
        tjkBetSlipOptions.hippodrome = hippodrome;
        tjkBetSlipOptions.bettingType = getAvailableBettingTypes().find(function (el) { return Number(el.id) === betTypeId; });
        tjkBetSlipOptions.bettingSubType = getAvailableBettingSubTypes(hippodrome).find(function (el) { return Number(el.split('-')[0]) === Number(coupon.race_id); });
        tjkBetSlipOptions.column = 1;
        tjkBetSlipOptions.betSlipMultiply = coupon.multiply;
        try {
            if (tjkFobBettingTypes.includes(betTypeId)) {
                // FOB tek-koşu tipleri: 1881, 1882, 1884, 1885, 1886, 1887, 1888
                // her leg tek bir at seçimi, tüm atlar aynı koşudan
                var _run_1 = hippodrome.runs.find(function (r) { return Number(r.no) === Number(coupon.race_id); });
                coupon.legs.forEach(function (leg, legIndex) {
                    leg.forEach(function (horseNo) {
                        var cleanNo = String(horseNo).replace(/T[234]$/, '');
                        var _horse = _run_1.horses.find(function (h) { return Number(h.no) === Number(cleanNo); });
                        if (_horse === null || _horse === void 0 ? void 0 : _horse.run_status) {
                            tjkBetslipStore.push({
                                hippodrome: hippodrome,
                                bettingType: tjkBetSlipOptions.bettingType,
                                bettingSubType: tjkBetSlipOptions.bettingSubType,
                                column: tjkBetSlipOptions.column,
                                run: _run_1,
                                horse: _horse
                            });
                        }
                    });
                });
            }
            else if (!tjkFobBettingTypes.includes(betTypeId) && ((_d = tjkBetSlipOptions.bettingType) === null || _d === void 0 ? void 0 : _d.columnLabel) === 'At') {
                // Aynı koşu, farklı kolonlar: İkili, Üçlü, Sıralı İkili, Tabela vb.
                // runNo hiç değişmez, sadece column artar
                var _run_2 = hippodrome.runs.find(function (r) { return Number(r.no) === Number(coupon.race_id); });
                coupon.legs.forEach(function (leg, legIndex) {
                    leg.forEach(function (horseNo) {
                        var _horse = _run_2.horses.find(function (h) { return Number(h.no) === Number(horseNo); });
                        if (_horse === null || _horse === void 0 ? void 0 : _horse.run_status) {
                            tjkBetslipStore.push({
                                hippodrome: hippodrome,
                                bettingType: tjkBetSlipOptions.bettingType,
                                bettingSubType: tjkBetSlipOptions.bettingSubType,
                                column: legIndex + 1,
                                run: _run_2,
                                horse: _horse
                            });
                        }
                    });
                });
            }
            else {
                // Çoklu koşu tipleri: Ganyan, Plase, Çifte, 3'lü/4'lü/5'li/6'lı/7'li Ganyan vb.
                // her leg farklı bir koşuya karşılık gelir
                coupon.legs.forEach(function (leg, legIndex) {
                    var runNo = Number(coupon.race_id) + legIndex;
                    var _run = hippodrome.runs.find(function (r) { return Number(r.no) === runNo; });
                    leg.forEach(function (horseNo) {
                        var _horse = _run.horses.find(function (h) { return Number(h.no) === Number(horseNo); });
                        if (_horse === null || _horse === void 0 ? void 0 : _horse.run_status) {
                            tjkBetslipStore.push({
                                hippodrome: hippodrome,
                                bettingType: tjkBetSlipOptions.bettingType,
                                bettingSubType: tjkBetSlipOptions.bettingSubType,
                                column: legIndex + 1,
                                run: _run,
                                horse: _horse
                            });
                        }
                    });
                });
            }
        }
        catch (e) {
            tjkBetslipStore.splice(0);
            tjkBetSlipOptions.hippodrome = null;
            tjkBetSlipOptions.bettingType = null;
            tjkBetSlipOptions.bettingSubType = null;
            return;
        }
        updateBetCount.status = true;
        betSlipActionSubject.next({ action: "clear", data: null });
        // console.log("coupon ->> ", coupon)
        // console.log("betType ->> ", betType)
        // console.log("options ->> ", tjkBetSlipOptions)
        // console.log("store ->> ", tjkBetslipStore)
        var bultenPath = tjkFobBettingTypes.includes(Number(coupon.bet_type)) ? 'fob-bulten' : 'bulten';
        navigate("/".concat(paths.TJK, "/").concat(bultenPath, "/").concat(hippodrome.keyword.toLowerCase(), "/"));
    }
    else {
        modalServiceSubject.next({
            title: 'Kapanmış Bahis',
            innerHtml: true,
            content: '<div class="text-center"><p>Bu kupon artık oynanabilir değil.</p></div>',
            confirm: {
                cancel: {
                    label: "Tamam",
                },
            },
        });
    }
}
var paramStates = {
    'devam-edenler': 1,
    kazanan: 2,
    kaybeden: 3,
    iptal: 4,
    kayitli: 6,
};
var states = {
    0: 'MBS Cevabı Bekleniyor',
    1: 'Devam eden',
    2: 'Kazanan',
    3: 'Kaybeden',
    4: 'İptal',
    5: 'Oynanmadı / Hatalı',
    6: 'Kayıtlı',
    8: 'MBS İptal Bekleniyor',
    9: 'İade',
};
export function TjkCoupons(props) {
    var params = props.params;
    var navigate = useNavigate();
    var _a = React.useState(null), couponList = _a[0], setCouponList = _a[1];
    var api = new ApiService();
    // @ts-ignore
    var couponStatus = paramStates[params.couponId];
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    useEffect(function () {
        window.scrollTo(0, 0);
        // @ts-ignore
        document.getElementById('accountPageLoading').style.display = 'block';
        var data = {
            token: Storage.get('token'),
            status: couponStatus < 2 ? '0,1' : couponStatus,
            page: 1,
        };
        api
            .start('post', env.tjk_api + "/order/api/tjk/get-coupons/", data, false)
            .then(function (res) {
            if (res.status) {
                if (DailyRaces.length === 0) {
                    getDailyRaces().then(function () {
                        getAvailableHippodromes();
                        setCouponList(res.data.data);
                    });
                }
                else {
                    setCouponList(res.data.data);
                }
                // @ts-ignore
                document.getElementById('accountPageLoading').style.display = 'none';
            }
            else {
                modalServiceSubject.next({
                    title: 'Hata',
                    content: res.message,
                    confirm: {
                        sure: res.message.indexOf('Oturum') !== -1
                            ? {
                                label: 'Giriş Yap',
                                action: function () {
                                    navigate('/giris-yap');
                                },
                            }
                            : null,
                        cancel: {
                            label: 'Tamam',
                        },
                    },
                });
                // @ts-ignore
                document.getElementById('accountPageLoading').style.display = 'none';
            }
        })
            .catch(function (error) {
            modalServiceSubject.next({
                title: 'Teknik hata',
                content: error,
                confirm: {
                    cancel: {
                        label: 'Tamam',
                    },
                },
            });
            // @ts-ignore
            document.getElementById('accountPageLoading').style.display = 'none';
        });
    }, [params.couponId]);
    var changePage = function (url) {
        if (url !== window.location.pathname) {
            setCouponList([]);
            navigate(url);
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "widget card" }, { children: [_jsxs("div", __assign({ className: "header" }, { children: [isMobile && _jsx(GameOperationsSelect, {}, void 0), !isMobile && (_jsx("h1", { children: "At Yar\u0131\u015F\u0131 Kuponlar\u0131m" }, void 0)), _jsxs("ul", __assign({ className: "tabs clearfix" }, { children: [_jsx("li", __assign({ className: 'cursor-pointer tab ' + (couponStatus < 2 ? 'active' : ''), onClick: function () { return changePage('/hesabim/tjk/devam-edenler'); } }, { children: "Devam Eden" }), void 0), _jsx("li", __assign({ className: 'cursor-pointer tab ' + (couponStatus === 2 ? 'active' : ''), onClick: function () { return changePage('/hesabim/tjk/kazanan'); } }, { children: "Kazanan" }), void 0), _jsx("li", __assign({ className: 'cursor-pointer tab ' + (couponStatus === 3 ? 'active' : ''), onClick: function () { return changePage('/hesabim/tjk/kaybeden'); } }, { children: "Kaybeden" }), void 0), _jsx("li", __assign({ className: 'cursor-pointer tab ' + (couponStatus === 4 ? 'active' : ''), onClick: function () { return changePage('/hesabim/tjk/iptal'); } }, { children: "\u0130ptal" }), void 0), _jsx("li", __assign({ className: 'cursor-pointer tab ' + (couponStatus === 6 ? 'active' : ''), onClick: function () { return changePage('/hesabim/tjk/kayitli'); } }, { children: "Kay\u0131tl\u0131" }), void 0)] }), void 0)] }), void 0), _jsx("div", __assign({ id: "InfiniteScroll", className: "body p-0 " }, { children: couponList ? (_jsx(_Fragment, { children: couponList.length > 0 ? (_jsx(ListTjkCoupons, { params: params, couponList: couponList, setCouponList: setCouponList }, void 0)) : (_jsxs("p", __assign({ className: "text-center p-5" }, { children: [states[couponStatus], " kuponunuz bulunmamaktad\u0131r."] }), void 0)) }, void 0)) : (_jsx(_Fragment, { children: _jsx("p", __assign({ className: "text-center p-5" }, { children: "Y\u00FCkleniyor! L\u00FCtfen bekleyiniz." }), void 0) }, void 0)) }), void 0)] }), void 0) }, void 0));
}
function ListTjkCoupons(props) {
    var navigate = useNavigate();
    var forceUpdate = useForceUpdate();
    var params = props.params;
    var couponList = props.couponList;
    var setCouponList = props.setCouponList;
    var api = new ApiService();
    var width = window.innerWidth;
    var isMobile = width < 986 ? true : false;
    // @ts-ignore
    var couponStatus = paramStates[params.couponId];
    var cancelTjkCoupon = function (c) {
        modalServiceSubject.next({
            title: 'Emin misiniz?',
            content: "".concat(c.approve_code, " numaral\u0131 kuponunuzu iptal etmek istedi\u011Finizden emin misiniz?"),
            confirm: {
                sure: {
                    class: 'btn-danger',
                    label: 'İptal et',
                    action: function () {
                        var loadingEl = document.getElementById('accountPageLoading');
                        if (loadingEl)
                            loadingEl.style.display = 'block';
                        api
                            .start('post', env.tjk_api + '/order/api/tjk/cancel-coupon/', {
                            token: Storage.get('token'),
                            coupon_id: c.id,
                        }, false)
                            .then(function (res) {
                            if (loadingEl)
                                loadingEl.style.display = 'none';
                            if (res.status) {
                                var i = couponList.indexOf(c);
                                couponList.splice(i, 1);
                                setCouponList(__spreadArray([], couponList, true));
                                modalServiceSubject.next({
                                    title: 'Kupon İptal Edildi',
                                    content: "".concat(c.approve_code, " numaral\u0131 kuponunuz ba\u015Far\u0131yla iptal edildi."),
                                    confirm: {
                                        cancel: {
                                            label: 'Tamam',
                                        },
                                    },
                                });
                            }
                            else {
                                var modalTitle = 'İşlem başarısız!';
                                if (res &&
                                    res.data &&
                                    res.data.error &&
                                    res.data.error.error_description) {
                                    modalTitle = res.message;
                                    res.message += "<p>".concat(res.data.error.error_description, "</p>");
                                }
                                modalServiceSubject.next({
                                    title: modalTitle,
                                    content: res.message,
                                    timeout: 10000,
                                    confirm: {
                                        cancel: {
                                            label: 'Tamam',
                                        },
                                    },
                                });
                            }
                        })
                            .catch(function (err) {
                            if (loadingEl)
                                loadingEl.style.display = 'none';
                            modalServiceSubject.next({
                                title: 'Hata',
                                content: err.toString(),
                                timeout: 3000,
                                confirm: {
                                    cancel: {
                                        label: 'Tamam',
                                    },
                                },
                            });
                        });
                    },
                },
                cancel: {
                    label: 'Vazgeç',
                },
            },
        });
    };
    var deleteTjkCoupon = function (c) {
        modalServiceSubject.next({
            title: 'Emin misiniz?',
            content: "#".concat(c.id, " numaral\u0131 kuponunuzu silmek istedi\u011Finizden emin misiniz?"),
            confirm: {
                sure: {
                    class: 'btn-danger',
                    label: 'Sil',
                    action: function () {
                        api
                            .start('post', env.tjk_api + '/order/api/tjk/delete-saved-coupon/', {
                            token: Storage.get('token'),
                            coupon_id: c.id,
                        }, false)
                            .then(function (res) {
                            if (res.status) {
                                var i = couponList.indexOf(c);
                                couponList.splice(i, 1);
                                setCouponList(__spreadArray([], couponList, true));
                            }
                            else {
                                var modalTitle = 'İşlem başarısız!';
                                if (res &&
                                    res.data &&
                                    res.data.error &&
                                    res.data.error.error_description) {
                                    modalTitle = res.message;
                                    res.message += "<p>".concat(res.data.error.error_description, "</p>");
                                }
                                modalServiceSubject.next({
                                    title: modalTitle,
                                    content: res.message,
                                    timeout: 10000,
                                    confirm: {
                                        cancel: {
                                            label: 'Tamam',
                                        },
                                    },
                                });
                            }
                        })
                            .catch(function (err) {
                            modalServiceSubject.next({
                                title: 'Hata',
                                content: err,
                                timeout: 3000,
                                confirm: {
                                    cancel: {
                                        label: 'Tamam',
                                    },
                                },
                            });
                        });
                    },
                },
                cancel: {
                    label: 'Vazgeç',
                },
            },
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("table", __assign({ className: "table" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Bilet" }, void 0), _jsx("th", __assign({ className: 'hidden-sm' }, { children: "Tarih" }), void 0), _jsx("th", __assign({ className: 'hidden-sm' }, { children: "Hipodrom" }), void 0), _jsx("th", __assign({ className: 'hidden-sm' }, { children: "Ko\u015Fu" }), void 0), _jsx("th", __assign({ className: 'hidden-sm' }, { children: "Bahis" }), void 0), _jsx("th", __assign({ className: 'hidden-sm' }, { children: "Misli/Oran" }), void 0), _jsx("th", { children: "Tutar" }, void 0), _jsx("th", __assign({ className: 'hidden-sm' }, { children: "Durum" }), void 0), couponStatus === 2 && _jsx("th", { children: "\u00D6deme" }, void 0), couponStatus === 1 && _jsx("th", { children: "\u0130ptal" }, void 0)] }, void 0) }, void 0), _jsx("tbody", { children: couponList.map(function (coupon, key) {
                            var _a, _b, _c;
                            coupon.displayPrice = coupon.status === 6 ? Number(coupon.amount || 0) : Number(coupon.amount / (coupon.unit === 1 ? 100 : 1) || 0);
                            if (coupon.status === 1) {
                                var availableHippodrome = availableHippodromes.find(function (h) {
                                    return Number(h.card_id) === Number(coupon.card_id) &&
                                        Number(h._date) === Number(parseTjkCard(coupon.card).dateNum);
                                });
                                if (availableHippodrome &&
                                    availableHippodrome.runs.find(function (r) {
                                        return r.status === 0 && Number(r.no) === Number(coupon.race_id);
                                    })) {
                                    if (tjkFobBettingTypes.includes(Number(coupon.bet_type))) {
                                        coupon.cancelable = false;
                                    }
                                    else {
                                        coupon.cancelable = true;
                                    }
                                }
                                else {
                                    coupon.cancelable = false;
                                }
                            }
                            return (_jsxs("tr", __assign({ className: "cursor-pointer", onClick: function (e) {
                                    if (!e.target.closest('button')) {
                                        tjkCouponDetailSubject.next(coupon);
                                    }
                                } }, { children: [_jsxs("td", __assign({ className: "text-center", style: isMobile ? { lineHeight: '18px' } : {} }, { children: [couponStatus === 6 ? '#' + coupon.id : coupon.approve_code, isMobile ? (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "d-block fw-bold" }, { children: tjkLongtermBettingTypes.includes(Number(coupon.bet_type))
                                                            ? (((_a = coupon.legs) === null || _a === void 0 ? void 0 : _a[0]) ? Object.values(coupon.legs[0])[0].hippodrome : '')
                                                            : (coupon.card &&
                                                                tjkHippodromsMap[parseTjkCard(coupon.card).hippodrome] &&
                                                                tjkHippodromsMap[parseTjkCard(coupon.card).hippodrome].YER) }), void 0), _jsxs("span", __assign({ className: "d-block" }, { children: [tjkBettingTypesMap[Number(coupon.bet_type)] &&
                                                                tjkBettingTypesMap[Number(coupon.bet_type)].name, !tjkLongtermBettingTypes.includes(Number(coupon.bet_type)) && "".concat(coupon.race_id, ". Ko\u015Fu")] }), void 0)] }, void 0)) : ('')] }), void 0), _jsx("td", __assign({ className: 'hidden-sm' }, { children: coupon.approve_date
                                            ? dateTimeFormat(coupon.approve_date)
                                            : dateTimeFormat(coupon.create_date) }), void 0), _jsx("td", __assign({ className: 'hidden-sm' }, { children: tjkLongtermBettingTypes.includes(Number(coupon.bet_type))
                                            ? (((_b = coupon.legs) === null || _b === void 0 ? void 0 : _b[0]) ? Object.values(coupon.legs[0])[0].hippodrome : '')
                                            : (coupon.card &&
                                                tjkHippodromsMap[parseTjkCard(coupon.card).hippodrome] &&
                                                tjkHippodromsMap[parseTjkCard(coupon.card).hippodrome].YER) }), void 0), _jsx("td", __assign({ className: 'hidden-sm' }, { children: tjkLongtermBettingTypes.includes(Number(coupon.bet_type)) ? '-' : coupon.race_id }), void 0), _jsx("td", __assign({ className: 'hidden-sm' }, { children: (_c = tjkBettingTypesMap2[Number(coupon.bet_type)]) === null || _c === void 0 ? void 0 : _c.name }), void 0), _jsx("td", __assign({ className: 'hidden-sm' }, { children: tjkFobBettingTypes.includes(Number(coupon.bet_type)) || tjkLongtermBettingTypes.includes(Number(coupon.bet_type))
                                            ? (Number(coupon.fob_odd_ratio) === 1 || Number(coupon.fob_odd_ratio) === 0 ? 'KO' : coupon.fob_odd_ratio)
                                            : coupon.multiply }), void 0), _jsxs("td", { children: [isMobile ? (_jsx(_Fragment, { children: _jsx("span", __assign({ className: 'd-block' }, { children: tjkFobBettingTypes.includes(Number(coupon.bet_type)) || tjkLongtermBettingTypes.includes(Number(coupon.bet_type))
                                                        ? "Oran:".concat(Number(coupon.fob_odd_ratio) === 1 || Number(coupon.fob_odd_ratio) === 0 ? 'KO' : coupon.fob_odd_ratio)
                                                        : "M:".concat(coupon.multiply) }), void 0) }, void 0)) : (''), _jsxs("span", __assign({ className: "fw-bold" }, { children: [currencyFormat(coupon.displayPrice), "\u20BA"] }), void 0)] }, void 0), _jsx("td", __assign({ className: 'hidden-sm ' +
                                            (couponStatus === 2 &&
                                                Number(coupon.displayPrice) !== Number(coupon.refund)
                                                ? ' text-success fw-bold '
                                                : ' fw-bold') }, { children: couponStatus !== 6 ? (states[coupon.status === 2 &&
                                            Number(coupon.displayPrice) === Number(coupon.refund)
                                            ? 9
                                            : coupon.status]) : (_jsx(_Fragment, { children: _jsx("button", __assign({ onClick: function () {
                                                    deleteTjkCoupon(coupon);
                                                }, className: 'btn btn-small btn-danger' }, { children: "Sil" }), void 0) }, void 0)) }), void 0), couponStatus === 2 && (_jsxs("td", __assign({ className: "text-success fw-bold" }, { children: [coupon.winning, "\u20BA"] }), void 0)), couponStatus === 1 && (_jsxs("td", __assign({ className: "text-right" }, { children: [isMobile && (_jsx("span", __assign({ className: "d-block" }, { children: coupon.approve_date
                                                    ? dateTimeFormat(coupon.approve_date)
                                                    : dateTimeFormat(coupon.create_date) }), void 0)), coupon.cancelable && (_jsx("button", __assign({ onClick: function () {
                                                    cancelTjkCoupon(coupon);
                                                }, className: 'btn btn-small btn-danger' }, { children: "\u0130ptal et" }), void 0))] }), void 0))] }), "order-tjk-coupon-".concat(key)));
                        }) }, void 0)] }), void 0), _jsx(TjKCouponDetail, {}, void 0)] }, void 0));
}
export var resultsOfTjkHippodroms = {};
export function TjKCouponDetail() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var token = Storage.get('token');
    var _l = useState(null), coupon = _l[0], setCoupon = _l[1];
    var _m = useState(false), playable = _m[0], setPlayable = _m[1];
    var navigate = useNavigate();
    var api = new ApiService();
    var scores = [];
    var runs = [];
    var date = null;
    var horseSeperator = ',';
    var runSeperator = '/';
    var width = window.innerWidth;
    var isMobile = width < 986 ? true : false;
    function closeModal() {
        setCoupon(null);
    }
    useEffect(function () {
        var couponDetailSubject_subscription = tjkCouponDetailSubject.subscribe(function (res) {
            date = parseTjkCard(res.card).dateFormatted;
            if (!resultsOfTjkHippodroms[date]) {
                // let apiUrl = `https://sportsbook.oley.com/tjk/results/?date=${date}`;
                var apiUrl = env.ekuri_bulletin_api +
                    "/api/results/".concat(date.split('-')[2]).concat(date.split('-')[1]).concat(date.split('-')[0], "/");
                api.start('get', apiUrl, null, true).then(function (result) {
                    if (result.status) {
                        resultsOfTjkHippodroms[date] = result.data;
                    }
                    setCoupon(res);
                });
            }
            else {
                setCoupon(res);
            }
        });
        return function () {
            couponDetailSubject_subscription.unsubscribe();
        };
    }, []);
    if (coupon) {
        if ([2, 4].includes(coupon.bet_type)) {
            horseSeperator = '/';
            runSeperator = '/';
        }
        coupon.runObjects = {};
        var _o = coupon.card ? parseTjkCard(coupon.card) : { dateNum: '', hippodrome: '', dateFormatted: '' }, couponDateNum_1 = _o.dateNum, couponHippodrome = _o.hippodrome, couponDateFormatted = _o.dateFormatted;
        date = couponDateFormatted;
        var hippodrome = DailyRaces.find(function (h) {
            return Number(h.card_id) === Number(coupon.card_id) &&
                Number(h._date) === Number(couponDateNum_1);
        });
        if (hippodrome && hippodrome.runs) {
            for (var _i = 0, _p = hippodrome.runs; _i < _p.length; _i++) {
                var rRun = _p[_i];
                rRun.is_finished = false;
                coupon.runObjects[String(rRun.no)] = rRun;
            }
        }
        hippodrome = resultsOfTjkHippodroms[date].find(function (el) { return el.id.split('-')[1] === parseTjkCard(coupon.card).hippodrome; });
        if (hippodrome && hippodrome.runs) {
            for (var _q = 0, _r = hippodrome.runs; _q < _r.length; _q++) {
                var rRun = _r[_q];
                rRun.is_finished = true;
                coupon.runObjects[String(rRun.no)] = rRun;
            }
        }
        if (tjkLongtermBettingTypes.includes(Number(coupon.bet_type))) {
            var leg = (_a = coupon.legs) === null || _a === void 0 ? void 0 : _a[0];
            var selection = leg ? Object.values(leg)[0] : null;
            scores.push(selection ? String(selection.no) : '-');
        }
        else if (tjkOrderedBetTypes.includes(Number(coupon.bet_type))) {
            var run = coupon.runObjects[String(coupon.race_id)];
            for (var i in Array.from(Array((_b = tjkBettingTypesMap2[Number(coupon.bet_type)]) === null || _b === void 0 ? void 0 : _b.column).keys())) {
                var winners = [];
                if (run) {
                    winners.push(run.horses[i].no);
                    scores.push(winners.sort().join(horseSeperator));
                }
                else {
                    scores.push('-');
                }
            }
        }
        else if (tjkSortedBetTypes.includes(Number(coupon.bet_type))) {
            var run = coupon.runObjects[String(coupon.race_id)];
            for (var i in Array.from(Array(tjkBettingTypesMap2[Number(coupon.bet_type)].horseCount).keys())) {
                scores.push(run && run.horses ? run.horses[i].no : '-');
            }
        }
        else if (Number(coupon.bet_type) === 1883) {
            var _loop_2 = function (leg) {
                var legKey = Object.keys(leg)[0];
                var _u = legKey.split('_'), legPrefix = _u[0], legRunNo = _u[1];
                var legKeyword = parseTjkCard(legPrefix).hippodrome;
                var resultHip = (_c = resultsOfTjkHippodroms[date]) === null || _c === void 0 ? void 0 : _c.find(function (h) { var _a; return ((_a = h.id.split('-')[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === legKeyword.toLowerCase(); });
                var resultRun = (_d = resultHip === null || resultHip === void 0 ? void 0 : resultHip.runs) === null || _d === void 0 ? void 0 : _d.find(function (r) { return String(r.no) === String(legRunNo); });
                if (resultRun && resultRun.horses) {
                    var winner = resultRun.horses.find(function (h) { return String(h.result) === '1'; });
                    scores.push(winner ? String(winner.no) : '-');
                }
                else {
                    scores.push('-');
                }
            };
            for (var _s = 0, _t = coupon.legs; _s < _t.length; _s++) {
                var leg = _t[_s];
                _loop_2(leg);
            }
        }
        else {
            for (var i in Array.from(Array(coupon.legs.length).keys())) {
                var run = coupon.runObjects[String(Number(coupon.race_id) + Number(i))];
                if (run && run.is_finished) {
                    var winners = [];
                    winners.push(run.horses[0].no);
                    if (String(run.horses[0].result) === '1' &&
                        String(run.horses[1].result) === '1') {
                        winners.push(run.horses[1].no);
                    }
                    if (agfCondBets.includes(coupon.bet_type)) {
                        var AGF = 0;
                        if (run.horses[0].AGF_rank2 &&
                            Number(run.horses[0].AGF_rank2) === 1) {
                            AGF = Number(run.horses[0].AGF_rank2);
                        }
                        if (run.horses[0].AGF_rank2 &&
                            Number(run.horses[0].AGF_rank2) === 1 &&
                            run.horses[0].AGF_rank1 &&
                            Number(run.horses[0].AGF_rank1) === 1) {
                            AGF = Number(run.horses[0].AGF_rank1);
                        }
                        if (run.horses[1].AGF_rank1 &&
                            Number(run.horses[1].AGF_rank1) === 1) {
                            AGF = 1;
                        }
                        if (run.horses[0].EFG) {
                            AGF = 1;
                        }
                        if (AGF === 1) {
                            if (run.is_finished === true) {
                                var kosmazAts = run.horses
                                    .filter(function (k) { return k.result === null && k.degree === null; })
                                    .map(function (k) { return k.no; });
                                winners.push.apply(winners, kosmazAts);
                            }
                            else {
                                var kosmazAts = run.horses
                                    .filter(function (k) { return k.run_status === false; })
                                    .map(function (k) { return k.no; });
                                winners.push.apply(winners, kosmazAts);
                            }
                        }
                        if (Number(coupon.bet_type) === 19) {
                            winners.push(run.horses[1].no);
                        }
                    }
                    else if ([47, 48].includes(coupon.bet_type)) {
                        winners.push(run.horses[1].no);
                        if (run.horses[2]) {
                            winners.push(run.horses[2].no);
                        }
                    }
                    else if ([2, 4].includes(coupon.bet_type)) {
                        winners.push(run.horses[1].no);
                    }
                    scores.push(winners.sort().join(horseSeperator));
                }
                else {
                    scores.push('-');
                }
            }
        }
        coupon.displayPrice = coupon.status === 6 ? Number(coupon.amount || 0) : Number(coupon.amount / (coupon.unit === 1 ? 100 : 1) || 0);
    }
    // @ts-ignore
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ isOpen: coupon ? true : false, onRequestClose: closeModal, style: {
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    maxWidth: 'calc(100vw - 40px)',
                    width: '920px',
                    padding: '0px',
                    maxHeight: 'calc(100vh - 100px)',
                    transform: 'translate(-50%, -50%)',
                    background: 'var(--color-bg-white)',
                },
            }, contentLabel: "" }, { children: coupon ? (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "card coupon" }, { children: [_jsxs("div", __assign({ className: "card-title p-2 ".concat(states[coupon.status]) }, { children: [_jsx("h3", __assign({ className: "m-0" }, { children: "Kupon Detay\u0131" }), void 0), _jsx("div", __assign({ className: 'float-right' }, { children: _jsx("img", { src: ExitIcon, width: 24, className: 'float-right cursor-p invert-color', onClick: function () { return closeModal(); } }, void 0) }), void 0)] }), void 0), _jsxs("div", __assign({ className: "card-body page account-page p-0", id: '#couponSlip_' + coupon.id }, { children: [_jsx("table", __assign({ className: "table table-striped table-bordered" }, { children: _jsxs("tbody", { children: [_jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Kupon No" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: coupon.approve_code }), void 0), _jsx("th", __assign({ className: "text-left hidden-sm" }, { children: "Bahis T\u00FCr\u00FC" }), void 0), _jsx("td", __assign({ className: "text-left hidden-sm" }, { children: (_e = tjkBettingTypesMap2[Number(coupon.bet_type)]) === null || _e === void 0 ? void 0 : _e.name }), void 0)] }, void 0), isMobile && (_jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Bahis T\u00FCr\u00FC" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: (_f = tjkBettingTypesMap2[Number(coupon.bet_type)]) === null || _f === void 0 ? void 0 : _f.name }), void 0)] }, void 0)), _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Tarih" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: dateTimeFormat(coupon.approve_date || coupon.create_date) }), void 0), _jsx("th", __assign({ className: "text-left hidden-sm" }, { children: "Hipodrom" }), void 0), _jsx("td", __assign({ className: "text-left hidden-sm" }, { children: tjkLongtermBettingTypes.includes(Number(coupon.bet_type))
                                                            ? (((_g = coupon.legs) === null || _g === void 0 ? void 0 : _g[0]) ? Object.values(coupon.legs[0])[0].hippodrome : '')
                                                            : (coupon.card &&
                                                                tjkHippodromsMap[parseTjkCard(coupon.card).hippodrome]
                                                                ? tjkHippodromsMap[parseTjkCard(coupon.card).hippodrome].YER
                                                                : parseTjkCard(coupon.card).hippodrome) }), void 0)] }, void 0), isMobile && (_jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Hipodrom" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: tjkLongtermBettingTypes.includes(Number(coupon.bet_type))
                                                            ? (((_h = coupon.legs) === null || _h === void 0 ? void 0 : _h[0]) ? Object.values(coupon.legs[0])[0].hippodrome : '')
                                                            : (coupon.card &&
                                                                tjkHippodromsMap[parseTjkCard(coupon.card).hippodrome]
                                                                ? tjkHippodromsMap[parseTjkCard(coupon.card).hippodrome].YER
                                                                : parseTjkCard(coupon.card).hippodrome) }), void 0)] }, void 0)), _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Ko\u015Fu" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: tjkLongtermBettingTypes.includes(Number(coupon.bet_type)) ? '-' : coupon.race_id }), void 0), tjkFobBettingTypes.includes(Number(coupon.bet_type)) || tjkLongtermBettingTypes.includes(Number(coupon.bet_type)) ? (_jsxs(_Fragment, { children: [_jsx("th", __assign({ className: "text-left hidden-sm" }, { children: "Toplam Oran" }), void 0), _jsx("td", __assign({ className: "text-left hidden-sm" }, { children: Number(coupon.fob_odd_ratio) === 1 || Number(coupon.fob_odd_ratio) === 0 ? 'KO' : coupon.fob_odd_ratio }), void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [_jsx("th", __assign({ className: "text-left hidden-sm" }, { children: "Misli" }), void 0), _jsx("td", __assign({ className: "text-left hidden-sm" }, { children: coupon.multiply }), void 0)] }, void 0))] }, void 0), isMobile && (_jsx("tr", { children: tjkFobBettingTypes.includes(Number(coupon.bet_type)) || tjkLongtermBettingTypes.includes(Number(coupon.bet_type)) ? (_jsxs(_Fragment, { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Toplam Oran" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: Number(coupon.fob_odd_ratio) === 1 || Number(coupon.fob_odd_ratio) === 0 ? 'KO' : coupon.fob_odd_ratio }), void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Misli" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: coupon.multiply }), void 0)] }, void 0)) }, void 0)), _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Bahis Say\u0131s\u0131" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: coupon.bet_count }), void 0), _jsx("th", __assign({ className: "text-left hidden-sm" }, { children: "Tutar" }), void 0), _jsxs("td", __assign({ className: "text-left hidden-sm" }, { children: [currencyFormat(coupon.displayPrice), "\u20BA"] }), void 0)] }, void 0), isMobile && (_jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Tutar" }), void 0), _jsxs("td", __assign({ className: "text-left" }, { children: [currencyFormat(Number(coupon.displayPrice)), "\u20BA"] }), void 0)] }, void 0)), (tjkFobBettingTypes.includes(Number(coupon.bet_type)) || tjkLongtermBettingTypes.includes(Number(coupon.bet_type))) && (_jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Tahmini Kazan\u00E7" }), void 0), _jsx("td", __assign({ className: "text-left", colSpan: 3 }, { children: Number(coupon.fob_odd_ratio) === 1 || Number(coupon.fob_odd_ratio) === 0 ? '-' : "".concat(coupon.fob_profit, "\u20BA") }), void 0)] }, void 0)), _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Sonu\u00E7lar" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: scores.join(runSeperator) }), void 0), _jsx("th", __assign({ className: 'text-left hidden-sm fw-bold ' +
                                                            (coupon.status === 2 ? ' text-success ' : '') }, { children: coupon.status === 2 ? 'Kazanç' : 'Durum' }), void 0), _jsx("td", __assign({ className: 'text-left hidden-sm fw-bold ' +
                                                            (coupon.status === 2 ? ' text-success ' : '') }, { children: coupon.status === 2 ? (_jsxs(_Fragment, { children: [coupon.refund !== coupon.winning &&
                                                                    coupon.winning + '₺', coupon.refund && Number(coupon.refund) > 0 ? (_jsxs("span", __assign({ className: "d-block text-dark fw-normal" }, { children: ["( ", coupon.refund, "\u20BA iade)"] }), void 0)) : (_jsx(_Fragment, {}, void 0))] }, void 0)) : (_jsx(_Fragment, { children: states[coupon.status] }, void 0)) }), void 0)] }, void 0), coupon.status !== 2 && isMobile && (_jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Durum" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: states[coupon.status] }), void 0)] }, void 0)), coupon.status === 2 && isMobile && (_jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Kazan\u00E7" }), void 0), _jsxs("td", __assign({ className: "text-left text-success fw-bold" }, { children: [coupon.refund !== coupon.winning &&
                                                                coupon.winning + '₺', coupon.refund && Number(coupon.refund) > 0 ? (_jsxs("span", __assign({ className: "d-block text-dark fw-normal" }, { children: ["( ", coupon.refund, "\u20BA iade)"] }), void 0)) : (_jsx(_Fragment, {}, void 0))] }), void 0)] }, void 0))] }, void 0) }), void 0), _jsx("div", __assign({ className: "".concat(!isMobile && 'row ml-0 mr-0', " agf-tables"), style: { width: 'auto', marginTop: '25px' } }, { children: Number(coupon.bet_type) === 1889
                                        ? (function () {
                                            var _a;
                                            var leg = (_a = coupon.legs) === null || _a === void 0 ? void 0 : _a[0];
                                            if (!leg)
                                                return null;
                                            var selection = Object.values(leg)[0];
                                            return (_jsxs("div", __assign({ className: "col-12 p-0" }, { children: [_jsx("div", __assign({ className: "run-no", style: {
                                                            background: 'var(--color-bg-dark)',
                                                            color: 'var(--color-text-lighter)'
                                                        } }, { children: _jsx("span", { children: selection.hippodrome }, void 0) }), void 0), _jsx("div", __assign({ className: "horse-no d-flex p-1", style: { background: 'var(--color-bg-white)' } }, { children: _jsx("div", __assign({ className: "text-left", style: { width: '100%', paddingLeft: 5 } }, { children: selection.description }), void 0) }), void 0)] }), void 0));
                                        })()
                                        : Number(coupon.bet_type) === 1883
                                            ? (function () {
                                                var _a;
                                                var legGroups = [];
                                                var seenKeys = {};
                                                for (var _i = 0, _b = coupon.legs; _i < _b.length; _i++) {
                                                    var leg = _b[_i];
                                                    var lk = Object.keys(leg)[0];
                                                    if (seenKeys[lk] !== undefined) {
                                                        (_a = legGroups[seenKeys[lk]].horses).push.apply(_a, leg[lk]);
                                                    }
                                                    else {
                                                        seenKeys[lk] = legGroups.length;
                                                        legGroups.push({ key: lk, horses: __spreadArray([], leg[lk], true) });
                                                    }
                                                }
                                                return legGroups.map(function (_a, groupIdx) {
                                                    var _b, _c, _d, _e, _f, _g;
                                                    var legKey = _a.key, horseNos = _a.horses;
                                                    var parts = legKey.split('_');
                                                    var legRunNo = parts[1];
                                                    var legBetTypeId = parts[2];
                                                    var legKeyword = parseTjkCard(parts[0]).hippodrome;
                                                    var betTypeName = (_c = (_b = tjkBettingTypesMap[Number(legBetTypeId)]) === null || _b === void 0 ? void 0 : _b.name) === null || _c === void 0 ? void 0 : _c.split(' - ')[0];
                                                    var hipName = ((_d = tjkHippodromsMap[legKeyword]) === null || _d === void 0 ? void 0 : _d.YER) || legKeyword;
                                                    var resultHip = (_e = resultsOfTjkHippodroms[date]) === null || _e === void 0 ? void 0 : _e.find(function (h) { var _a; return ((_a = h.id.split('-')[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === legKeyword.toLowerCase(); });
                                                    var rRun = (_f = resultHip === null || resultHip === void 0 ? void 0 : resultHip.runs) === null || _f === void 0 ? void 0 : _f.find(function (r) { return String(r.no) === String(legRunNo); });
                                                    var isFinished = !!rRun;
                                                    if (!rRun) {
                                                        var liveHip = DailyRaces.find(function (h) { var _a; return ((_a = h.keyword) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === legKeyword.toLowerCase(); });
                                                        rRun = (_g = liveHip === null || liveHip === void 0 ? void 0 : liveHip.runs) === null || _g === void 0 ? void 0 : _g.find(function (r) { return String(r.no) === String(legRunNo); });
                                                    }
                                                    var isFobPair = [1884, 1885].includes(Number(legBetTypeId)) && horseNos.length === 2;
                                                    return (_jsxs("div", __assign({ className: "col-12 p-0" }, { children: [_jsxs("div", __assign({ className: "run-no", style: {
                                                                    background: 'var(--color-bg-dark)',
                                                                    color: 'var(--color-text-lighter)'
                                                                } }, { children: [_jsxs("span", { children: [legRunNo, ".Ko\u015Fu (", hipName, ")"] }, void 0), _jsx("br", {}, void 0), betTypeName && (_jsxs("span", { children: ["(", betTypeName, ")"] }, void 0))] }), void 0), isFobPair ? (function () {
                                                                var _a, _b;
                                                                var h1 = (_a = rRun === null || rRun === void 0 ? void 0 : rRun.horses) === null || _a === void 0 ? void 0 : _a.find(function (h) { return String(h.no) === String(horseNos[0]).replace(/T[234]$/, ''); });
                                                                var h2 = (_b = rRun === null || rRun === void 0 ? void 0 : rRun.horses) === null || _b === void 0 ? void 0 : _b.find(function (h) { return String(h.no) === String(horseNos[1]).replace(/T[234]$/, ''); });
                                                                var hStatus = function (h) {
                                                                    if (!h)
                                                                        return '';
                                                                    if (isFinished) {
                                                                        if (h.result === null && h.degree === null)
                                                                            return ' (K)';
                                                                        return h.result !== null ? " (".concat(h.result, ")") : '';
                                                                    }
                                                                    return h.run_status === false ? ' (K)' : '';
                                                                };
                                                                return (_jsx("div", __assign({ className: "horse-no d-flex p-1", style: { background: 'var(--color-bg-white)' } }, { children: _jsxs("div", __assign({ className: "text-left", style: { width: '100%', paddingLeft: 5 } }, { children: [horseNos[0], "-", horseNos[1], ' ', h1 ? h1.name : horseNos[0], hStatus(h1), " - ", h2 ? h2.name : horseNos[1], hStatus(h2)] }), void 0) }), void 0));
                                                            })() : horseNos.map(function (horseNo, hIdx) {
                                                                var _a;
                                                                var actualNo = String(horseNo).replace(/T[234]$/, '');
                                                                var horse = (_a = rRun === null || rRun === void 0 ? void 0 : rRun.horses) === null || _a === void 0 ? void 0 : _a.find(function (h) { return String(h.no) === actualNo; });
                                                                return (_jsx("div", __assign({ className: "horse-no d-flex p-1", style: { background: 'var(--color-bg-white)' } }, { children: _jsx("div", __assign({ className: "text-left", style: { width: '100%', paddingLeft: 5 } }, { children: horse ? (_jsxs(_Fragment, { children: [horse.no, " - ", horse.name, isFinished
                                                                                    ? (horse.result === null && horse.degree === null ? ' (K)' : horse.result !== null ? " (".concat(horse.result, ")") : '')
                                                                                    : (horse.run_status === false ? ' (K)' : '')] }, void 0)) : horseNo }), void 0) }), "order-detail-horse-".concat(hIdx)));
                                                            })] }), "order-detail-legs-".concat(groupIdx)));
                                                });
                                            })()
                                            : coupon.legs.map(function (e, key) {
                                                // @ts-ignore
                                                e = (typeof e === 'object' && e !== null && !Array.isArray(e)) ? Array.from(Object.values(e)[0][0]) : e;
                                                var plusColumn = 0;
                                                if (tjkBettingTypesMap2[Number(coupon.bet_type)]
                                                    .columnLabel !== 'At') {
                                                    plusColumn = key;
                                                }
                                                var rRun = coupon.runObjects[coupon.race_id + plusColumn]; //runs.find((e:any)=>Number(e.no)===(coupon.race_id + plusColumn))
                                                return (_jsxs("div", __assign({ className: "col-2 p-sm-0 col-sm-12", style: !isMobile
                                                        ? {
                                                            width: "calc(100% / ".concat(coupon.legs.length, ")"),
                                                            flex: 'unset',
                                                            maxWidth: 'unset',
                                                        }
                                                        : {} }, { children: [_jsxs("div", __assign({ className: "run-no", style: isMobile
                                                                ? {
                                                                    background: 'var(--color-bg-dark)',
                                                                    color: 'var(--color-text-lighter)',
                                                                }
                                                                : {} }, { children: [tjkBettingTypesMap2[Number(coupon.bet_type)]
                                                                    .columnLabel === 'Koşu'
                                                                    ? Number(coupon.race_id) + Number(key)
                                                                    : Number(key + 1), ".", tjkBettingTypesMap2[Number(coupon.bet_type)]
                                                                    .columnLabel] }), void 0), e && (e === null || e === void 0 ? void 0 : e.map(function (item, horsekey) {
                                                            var horse = rRun && rRun.horses
                                                                ? rRun.horses.find(function (e) { return Number(e.no) === Number(item); })
                                                                : null;
                                                            return (_jsx("div", __assign({ className: "horse-no d-flex", style: isMobile
                                                                    ? { background: 'var(--color-bg-white)' }
                                                                    : {} }, { children: _jsx("div", __assign({ className: 'text-left ' +
                                                                        (horse &&
                                                                            scores[key] &&
                                                                            scores[key]
                                                                                .split(horseSeperator)
                                                                                .includes(horse.no)
                                                                            ? ' text-danger'
                                                                            : ''), style: { width: '100%', paddingLeft: 5 } }, { children: horse ? (_jsxs(_Fragment, { children: [horse.no, " - ", horse.name, rRun.is_finished ? (_jsx(_Fragment, { children: horse.result === null &&
                                                                                    horse.degree === null
                                                                                    ? '(K)'
                                                                                    : horse.result !== null
                                                                                        ? "(".concat(horse.result, ")")
                                                                                        : '' }, void 0)) : (_jsx(_Fragment, { children: horse.run_status === false
                                                                                    ? '(K)'
                                                                                    : '' }, void 0)), horse.stablemate &&
                                                                                Number(horse.stablemate) === 1 ? (_jsx(_Fragment, { children: _jsx("img", { src: iconFather, style: { filter: 'brightness(0)' } }, void 0) }, void 0)) : (_jsx(_Fragment, {}, void 0)), horse.stablemate &&
                                                                                Number(horse.stablemate) === 2 ? (_jsx(_Fragment, { children: _jsx("img", { src: iconFather, style: {
                                                                                        filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(359deg) brightness(94%) contrast(117%)',
                                                                                    } }, void 0) }, void 0)) : (_jsx(_Fragment, {}, void 0)), horse.stablemate &&
                                                                                Number(horse.stablemate) === 3 ? (_jsx(_Fragment, { children: _jsx("img", { src: iconFather }, void 0) }, void 0)) : (_jsx(_Fragment, {}, void 0)), horse.stablemate &&
                                                                                Number(horse.stablemate) === 4 ? (_jsx(_Fragment, { children: _jsx("img", { src: iconFather, style: {
                                                                                        filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(216deg) brightness(100%) contrast(117%)',
                                                                                    } }, void 0) }, void 0)) : (_jsx(_Fragment, {}, void 0)), horse.stablemate &&
                                                                                Number(horse.stablemate) === 5 ? (_jsx(_Fragment, { children: _jsx("img", { src: iconFather, style: {
                                                                                        filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(130deg) brightness(100%) contrast(117%)',
                                                                                    } }, void 0) }, void 0)) : (_jsx(_Fragment, {}, void 0))] }, void 0)) : (_jsx(_Fragment, { children: Number(item) === 32
                                                                            ? isMobile
                                                                                ? '(S)'
                                                                                : 'HAZIR BAHİS'
                                                                            : item }, void 0)) }), void 0) }), "order-detail-horse-".concat(horsekey)));
                                                        }))] }), "order-detail-legs-".concat(key)));
                                            }) }), void 0), _jsxs("div", __assign({ className: 'd-flex justify-content-center my-3' }, { children: [_jsxs("button", __assign({ className: 'icon-shere d-flex  btn btn-small', id: 'waButton' + coupon.id, style: {
                                                background: 'var(--color-bg-medium)',
                                                color: 'var(--color-text-medium)',
                                            }, disabled: false, onClick: function () {
                                                shareOnSocial(coupon, 1, 'tjk');
                                            } }, { children: [_jsx("img", { className: "invert-color cursor-pointer m-auto", src: Whatsapp, width: 14 }, void 0), "\u00A0 Payla\u015F"] }), void 0), [1, 6].includes(Number(coupon.status)) &&
                                            !((_k = (_j = coupon.runObjects) === null || _j === void 0 ? void 0 : _j[String(coupon.race_id)]) === null || _k === void 0 ? void 0 : _k.is_finished) && coupon.bet_type !== 1889 && (_jsx("button", __assign({ className: 'btn btn-small', onClick: function () {
                                                playTJKSavedCoupon(coupon, navigate);
                                            } }, { children: "Kuponu Oyna" }), void 0))] }), void 0)] }), void 0)] }), void 0) }, void 0)) : (_jsx(_Fragment, {}, void 0)) }), void 0) }, void 0));
}
